import React, { useState } from "react";
import cn from "classnames";
import style from "../common.module.scss";
import CustomButton from "../../../custom/custom-button/CustomButton";
import moment from "moment";
import { numberToFinanceFormat } from "../../../../utils";
import { Order } from "../../../../services";
import { toast } from "react-toastify";

const ListSuggestedPrices = ({
  items = [],
  fetchOrderData,
  isExpeditor = "",
  ordersStatus,
  onUpdateData,
}) => {
  const [isLoading, setLoading] = useState(false);

  const handleAcceptTender = (expeditorId) => {
    setLoading(true);
    Order.acceptTender(expeditorId)
      .then((res) => res.data)
      .then((response) => {
        toast.success("Предложение принято успешно!");
        setLoading(false);
        onUpdateData();
        fetchOrderData();
      })
      .catch((error) => {
        console.error("Ошибка при принятии предложения:", error);
        toast.error("Не удалось принять предложение, попробуйте позже.");
        setLoading(false);
      });
  };

  return (
    <div className={cn(style.cargo_wrapper, style.suggested_wrapper)}>
      <div className={cn(style.suggested_row, style.cargo_title, style.suggested_head)}>
        <div className={style.typography_small}>Название</div>
        <div className={style.typography_small}>Дата</div>
        <div className={style.typography_small}>Предложенная сумма</div>
        <CustomButton
          isMini
          text="Принять"
          isDisabled
          style={{ background: "transparent" }}
        />
      </div>
      {items.map((item) => (
        <div key={item.expeditorId} className={style.suggested_row}>
          <div className={cn(style.typography_titleSmall, style.suggested_lineClamp)}>
            {item.expeditorName}
          </div>
          <div className={style.typography_small}>
            {moment(item?.updatedAt).format("DD.MM.YYYY")} - {" "}
            {moment(item?.updatedAt).format("HH:mm")}
          </div>
          <div className={style.typography_titleSmall}>
            {numberToFinanceFormat(item.price)}〒
          </div>
          {ordersStatus === "awaitingoffer" && !isExpeditor ? (
            <CustomButton
              isMini
              text="Принять"
              onClick={() => handleAcceptTender(item.id)}
              isLoading={isLoading}
            />
          ) : isExpeditor === item.expeditorId ? (
            <span className={style.acceptedText}>Принятый</span>
          ) : null}
        </div>
      ))}
    </div>
  );
};

export default ListSuggestedPrices;
